import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'boxx-content-divider',
  templateUrl: './content-divider.component.html',
  styleUrls: ['./content-divider.component.scss'],
})
export class ContentDividerComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
